import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { CurrencyDollarIcon, ExternalLinkIcon } from "@heroicons/react/outline";
import { getOrders } from "../../redux/actions/orders";

export default function OrderList() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const { orders } = useSelector((state) => state.orders);

  console.log("ORDERS ", orders);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <>
      {orders.length !== 0 ? (
        <div className="py-4 sm:py-5 px-20">
          <div className="-ml-4 my-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
            <div className="ml-4 mt-4">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Order listings
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Here is the list of orders in chronological order.
              </p>
            </div>
            <div className="ml-4 mt-4 flex-shrink-0">
              <Link
                to="/manager/orders/add-order"
                className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
              >
                Create a new order
              </Link>
            </div>
          </div>
          <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
            {orders.map((order) => (
              <Link to={`/manager/order/${order.id}`}>
                <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                  <div className="w-0 flex-1 flex items-center">
                    <CurrencyDollarIcon
                      className="flex-shrink-0 h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                    <span className="ml-2 flex-1 w-0 truncate">
                      Order : {order.attributes.orderNo}
                    </span>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex space-x-4">
                    <span
                      type="button"
                      className="bg-white rounded-md font-medium text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                    >
                      {formatDate(order.attributes.orderDate)}
                    </span>
                    <span className="text-gray-300" aria-hidden="true">
                      |
                    </span>
                    <button
                      type="button"
                      className="inline-flex items-center bg-white rounded-md font-medium text-sky-600 hover:text-sky-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                    >
                      Details
                      <ExternalLinkIcon className="ml-1 h-6 w-6" />
                    </button>
                  </div>
                </li>
              </Link>
            ))}
          </ul>
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
}
